import React, { Fragment, useEffect, useRef, useState,  } from 'react'
import { Container, Row, Col, Modal, Form, Button, Table, Spinner } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import useAuth from '../../../../context/auth/useAuth'
import { Link, useParams } from 'react-router-dom'
import { getMenus } from '../../../../actions/menusActions'
import Swal from 'sweetalert2'
import { getRestaurant } from '../../../../actions/restaurantsActions'
import Select from "react-select"

import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from "@fullcalendar/interaction"
import '@fullcalendar/bootstrap5/main.css'
import '@fullcalendar/daygrid/main.css'
import esLocale from '@fullcalendar/core/locales/es'
import { addCalendar, editCalendar, getCalendarsByRestaurant, removeCalendar } from '../../../../actions/calendarsActions'

export default function Assignmenuscalendar() {
  	const { t } = useTranslation()
	const dispatch = useDispatch()
	const {client} = useAuth()
    const calendary = useRef(null)
    const { id } = useParams()
    const [events, setEvents] = useState([])

	const {calendars, resultcalendar, loading} = useSelector(state=>state.calendars)
	const {restaurant} = useSelector(state=>state.restaurants)
	const {menus} = useSelector(state=>state.menus)
    const [menuOptions, setMenusOptions] = useState({options: [], selected: null})
    const [showRegister, setShowRegister] = useState(false)
    const [isUpdating, setIsUpdating] = useState(false)

    //const dishesType = ['firstdishes', 'seconddishes', 'drinks', 'desserts', 'complements']
    const dishesType = ['firstdishes', 'seconddishes', 'desserts']
    // const comensalsType = ['dishes', 'drinks', 'desserts', 'complements']
    const comensalsType = ['dishes', 'desserts']

    //eslint-disable-next-line
    const [dishesToShow, setDishesToShow] = useState([])
    //eslint-disable-next-line
    // const [drinksToShow, setDrinksToShow] = useState([])
    //eslint-disable-next-line
    const [dessertsToShow, setDessertsToShow] = useState([])
    //eslint-disable-next-line
    // const [complementsToShow, setComplementsToShow] = useState([])

    const [firstdishesToSave, setFirstdishesToSave] = useState([])
    const [seconddishesToSave, setSeconddishesToSave] = useState([])
    // const [drinksToSave, setDrinksToSave] = useState([])
    const [dessertsToSave, setDessertsToSave] = useState([])
    // const [complementsToSave, setComplementsToSave] = useState([])

    // Estado para almacenar los platos seleccionados
    const [selectedDishes, setSelectedDishes] = useState([])

    // Estado para almacenar el rango de fechas y dias de la semana
    const [dateRange, setDateRange] = useState({ start: "", end: "" });
    const [selectedWeekdays, setSelectedWeekdays] = useState([]);
    const [showBatchModal, setShowBatchModal] = useState(false);
    const [showBatchLoading, setShowBatchLoading] = useState(false);

    // Función para manejar el cambio en el Select
    const handleDishSelection = (selectedOptions) => {
        setSelectedDishes(selectedOptions || []) // Actualizamos el estado con los platos seleccionados
    }

    // Convertir los platos en opciones para el Select
    const dishOptions = comensalsType.flatMap((dishType) =>
        eval(`${dishType}ToShow`).map((dish) => ({
            value: dish,
            label: dish.name
        }))
    )

    const [calendarFormState, setCalendarFormState] = useState({})
    const [modalShow, setModalShow] = useState(false)

	useEffect(() => {
		if(client){
            dispatch({type: 'CALENDAR_RESET'})
			dispatch(getMenus())
			dispatch(getCalendarsByRestaurant(id))
			dispatch(getRestaurant(id))
		}
	},[dispatch, t, id, client])

    useEffect(() => {
        if(menus){
            let selectMenusOptions = []
            let selectedMenusOption = {value: 0, label: t('global.select')}

            menus.forEach(menus => {
                let object = {value: menus._id, label: menus.name}
                selectMenusOptions.push(object)
            })
            setMenusOptions({options: selectMenusOptions, selected: selectedMenusOption})
        }
        //eslint-disable-next-line
    }, [menus])

    useEffect(() => {
        if(calendars){
            const newEvents = []
            calendars.map((menu) =>(
                newEvents.push({...menu, title: menu?.menu?.name, date_menu: menu?.date })
            ))
            setEvents(newEvents)
        }
    }, [calendars])

    const menuChange = (target)=>{
        setShowRegister(true)
        setSelectedDishes([])
        let selectMenuOptions = []
        let selectedMenuOption

        menus.forEach(menu => {
            let object = {value: menu._id, label: menu.name}
            selectMenuOptions.push(object)

            if(menu._id === target.value){
                selectedMenuOption = object
                setFirstdishesToSave(menu.firstdishes)
                setSeconddishesToSave(menu.seconddishes)
                // setDrinksToSave(menu.drinks)
                setDessertsToSave(menu.desserts)
                // setComplementsToSave(menu.complements)

                let arrayDishes1 = menu.firstdishes || []
                let arrayDishes2 = menu.seconddishes || []
                let dishesMap = {}
                // Primeros
                arrayDishes1.forEach(dish => {
                    dishesMap[dish._id] = {
                        ...dish,
                        name: `${dish.name} (1º)`
                    }
                })
                // Segundos
                arrayDishes2.forEach(dish => {
                    if (dishesMap[dish._id]) {
                        dishesMap[dish._id] = {
                            ...dish,
                            name: `${dish.name} (1º y 2º)`
                        }
                    } else {
                        dishesMap[dish._id] = {
                            ...dish,
                            name: `${dish.name} (2º)`
                        }
                    }
                })
                let arrayDishes = Object.values(dishesMap)
                setDishesToShow(arrayDishes)

                // setDrinksToShow(menu.drinks)
                setDessertsToShow(menu.desserts)


                // const uniqueObjectsComplements = menu.complements.filter(complement => {
                //     return !arrayDishes.some(item => item._id === complement.id) &&
                //             !menu.drinks.some(item => item.id === complement.id) &&
                //             !menu.desserts.some(item => item.id === complement.id)
                // })
                // setComplementsToShow(uniqueObjectsComplements)

                let arrayDishesComensals = {}
                dishesType.map((dishType) => (
                    menu[dishType]?.map((dish) => (
                        arrayDishesComensals[dish._id] = 0
                    ))
                ))

                setCalendarFormState({
                    ...calendarFormState,
                    restaurant: id,
                    menu: target.value,
                    start_time: '00:00',
                    end_time: '00:00',
                    dishesComensals: arrayDishesComensals,
                })
            }
        })
        setMenusOptions({options: selectMenuOptions, selected: selectedMenuOption})

    }

    const handleBatchEventCreation = () => {
        if (!dateRange.start || !dateRange.end || selectedWeekdays.length === 0 || !menuOptions.selected) {
            Swal.fire("Error", "Selecciona un rango de fechas, días de la semana y un menú.", "error");
            return;
        }
        const hasInvalidComensals = selectedDishes.some(dish => {
            const val = calendarFormState.dishesComensals?.[dish.value._id];
            return !val || parseInt(val) < 1;
        });
        if (hasInvalidComensals) {
            Swal.fire("Error", "Todos los platos seleccionados deben tener al menos 1 comensal.", "error");
            return;
        }
        setShowBatchLoading(true);

        const startDate = new Date(dateRange.start);
        const endDate = new Date(dateRange.end);
        let newEvents = [];

        const selectedMenu = menus.find(menu => menu._id === menuOptions.selected.value);

        if (!selectedMenu) return;

        let dishesComensals = {};
        selectedDishes.forEach(dish => {
            dishesComensals[dish.value._id] = calendarFormState.dishesComensals[dish.value._id] || 1;
        });

        let arrayNewMenus = []
        for (let d = new Date(startDate); d <= endDate; d.setDate(d.getDate() + 1)) {
            if (selectedWeekdays.includes(d.getDay())) {
                arrayNewMenus.push({
                    ...calendarFormState,
                    date: d.toISOString().split("T")[0],
                    firstdishes: selectedMenu.firstdishes.map(dish => dish._id),
                    seconddishes: selectedMenu.seconddishes.map(dish => dish._id),
                    desserts: selectedMenu.desserts.map(dish => dish._id)
                })
            }
        }

        dispatch(addCalendar(arrayNewMenus))
        setShowBatchModal(false);
    }

    const dateClickHandler = (arg) => {
        setShowRegister(false)
        setDishesToShow([])
        // setDrinksToShow([])
        setDessertsToShow([])
        // setComplementsToShow([])

        let selectMenusOptions = []
        let selectedMenusOption = {value: 0, label: t('global.select')}

        menus?.forEach(menus => {
            let object = {value: menus._id, label: menus.name}
            selectMenusOptions.push(object)
        })
        setMenusOptions({options: selectMenusOptions, selected: selectedMenusOption})

        let dateArg = ''
        if (arg?.dateStr) {
            dateArg = arg?.dateStr
        }

        setCalendarFormState({
            restaurant: id,
            date: dateArg,
            menu: '',
            dishesComensals: {},
        })

        setModalShow(true)
    }

    const eventsHandler = (e) => {
        const calendarData = e.event._def.extendedProps

        menus.forEach(menu => {
            if(menu._id === calendarData.menu._id){
                // Asegurarse de que las listas existen o asignar un array vacío por defecto
                let arrayDishes1 = menu.firstdishes || []
                let arrayDishes2 = menu.seconddishes || []
                let arrayDesserts = menu.desserts || []

                // Combinar las listas de platos en un solo array
                let allDishes = [...arrayDishes1, ...arrayDishes2, ...arrayDesserts]

                // Crear un Map para evitar duplicados basado en el atributo _id
                let uniqueDishesMap = new Map()
                allDishes.forEach(dish => {
                    if (!uniqueDishesMap.has(dish._id)) {
                        uniqueDishesMap.set(dish._id, dish);
                    }
                })

                // Convertir el Map de vuelta a un array
                let uniqueDishes = Array.from(uniqueDishesMap.values())

                // Filtrar los platos que tienen comensales asignados
                const dishesWithComensals = uniqueDishes.filter(dish =>
                    calendarData.dishescomensals[dish._id] > 0
                )

                // Mapear los platos filtrados a un formato para el selector
                const formattedSelectedDishes = dishesWithComensals.map(dish => ({
                    value: dish,
                    label: dish.name
                }))

                setSelectedDishes(formattedSelectedDishes)

                setDishesToShow(allDishes)
                // setDrinksToShowEdit(menu.drinks)


                // const uniqueObjectsComplements = menu.complements.filter(complement => {
                //     return !arrayDishes.some(item => item._id === complement.id) &&
                //             !menu.drinks.some(item => item.id === complement.id) &&
                //             !menu.desserts.some(item => item.id === complement.id)
                // })
                // setComplementsToShowEdit(uniqueObjectsComplements)
            }
        })

        setCalendarFormState({
            menu: calendarData.menu._id,
            restaurant: calendarData.restaurant._id,
            date: calendarData.date_menu,
            start_time: calendarData.start_time,
            end_time: calendarData.end_time,
            dishesOrdered: calendarData.dishesOrdered,
            firstdishes: calendarData.firstdishes,
            seconddishes: calendarData.seconddishes,
            // drinks: calendarData.drinks,
            desserts: calendarData.desserts,
            // complements: calendarData.complements,
            dishesComensals: calendarData.dishescomensals,
            id: calendarData._id
        })
        setModalShow(true)
    }

    const handleRemoveDish = (dishId) => {
        // Filtra los platos seleccionados para excluir el que se quiere eliminar
        const updatedDishes = selectedDishes.filter(dish => dish.value._id !== dishId)
        calendarFormState.dishesComensals[dishId]=0
        // Actualiza el estado de los platos seleccionados
        setSelectedDishes(updatedDishes)

        // Opcional: Actualiza también dishesComensals para eliminar los comensales correspondientes
        // const updatedDishesComensals = {...calendarFormState.dishesComensals}
        // delete updatedDishesComensals[dishId]
        // setCalendarFormState({
        //     ...calendarFormState,
        //     dishesComensals: updatedDishesComensals
        // })

    }

    const handleInputChange = (idDish, target)=>{
        let arrayComensals = calendarFormState?.dishesComensals

        if(target.target.value.trim() === 'e'){
            arrayComensals[idDish] = ''
        }else if(target.target.value.trim() === ''){
            arrayComensals[idDish] = ''
        }else{
            arrayComensals[idDish] = parseInt(target.target.value)
        }

        setCalendarFormState({
            ...calendarFormState,
            dishesComensals: arrayComensals
        })
    }

    const handleInputScheduleChange = (target)=>{
        setCalendarFormState({
            ...calendarFormState,
            [target.target.name]: target.target.value
        })
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        const hasInvalidComensals = selectedDishes.some(dish => {
            const val = calendarFormState.dishesComensals?.[dish.value._id];
            return !val || parseInt(val) < 1;
        });
        if (hasInvalidComensals) {
            Swal.fire("Error", "Todos los platos seleccionados deben tener al menos 1 comensal.", "error");
            return;
        }
        setShowBatchLoading(true);
        if(calendarFormState?.id){
            setIsUpdating(true)
            const toIdArray = (dishes) => dishes.map(d => d._id)
            const payload = {
            ...calendarFormState,
            firstdishes: toIdArray(calendarFormState.firstdishes),
            seconddishes: toIdArray(calendarFormState.seconddishes),
            desserts: toIdArray(calendarFormState.desserts),
            }
            dispatch(editCalendar(payload, calendarFormState.id))
            setIsUpdating(false)
        }else{
            const firstdishes = firstdishesToSave?.map(dish => dish._id)
            const seconddishes = seconddishesToSave?.map(dish => dish._id)
            const desserts = dessertsToSave?.map(dish => dish._id)

            dispatch(addCalendar([{
                ...calendarFormState,
                firstdishes: firstdishes,
                seconddishes: seconddishes,
                desserts: desserts,
                // drinks: drinksToSave,
                // complements: complementsToSave,
            }]))
        }
    }

    const unassignMenu = (idCalendar, e) =>{
        e.preventDefault()

        dispatch(removeCalendar(idCalendar))
    }

    const resetBatchModal = () => {
        setDateRange({ start: "", end: "" });
        setSelectedWeekdays([]);
        setMenusOptions({ options: menuOptions.options, selected: null });
        setSelectedDishes([]);
        setDishesToShow([]);
        setDessertsToShow([]);
        setShowBatchLoading(false);
        setCalendarFormState({
            menu: "",
            restaurant: id,
            date: "",
            start_time: "00:00",
            end_time: "00:00",
            dishesComensals: {},
        });
    };

    useEffect(() => {
        if(resultcalendar){
            switch (resultcalendar) {
                case 'success':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.calendars.addsuccess')
                    })
                    setModalShow(false)
                    setShowBatchLoading(false);
                    break;
                case 'editsuccess':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.calendars.editsuccess')
                    })
                    setModalShow(false)
                    setShowBatchLoading(false);
                    break;
                case 'editwrong':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.ok'),
                        icon: 'error',
                        text: t('admin.calendars.wrongcomensals')
                    })
                    setShowBatchLoading(false);
                    break;
                case 'deletesuccess':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.calendars.deletesuccess')
                    })
                    setModalShow(false)
                    break;
                case 'deletewrong':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.ok'),
                        icon: 'error',
                        text: t('admin.calendars.deletewrong')
                    })
                    break;
                case 'deletenotexist':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.ok'),
                        icon: 'error',
                        text: t('admin.calendars.deletenotexist')
                    })
                    setModalShow(false)
                    break;
                default:
                    break;
            }

            dispatch(getCalendarsByRestaurant(id))
        }
    // eslint-disable-next-line
    }, [resultcalendar])

	return (
        <Container className='p-5'>
            <Row className="mb-3">
                <Col xs={2} className='p-0'>
                    <Link className="p-0 my-3" to="/admin/assignmenus">
                        <img src="../../images/arrow-back.svg" alt="arrow-back" width={25}></img>
                    </Link>
                </Col>
                <Col xs={8} className='text-center'>
                    <h1 className='fs-18'>{t('admin.menus.assignmenus')}</h1>
                </Col>
                <Col xs={2}></Col>
            </Row>
            <Row className="mt-5 ">
                <Col xs={12} md={6}>
                    <label className='sd-label-medium'>{restaurant?.name}</label>
                </Col>
                <Col xs={12} md={6} className='d-flex justify-content-end'>
                    <Button variant="primary" className="mb-3" onClick={() => { resetBatchModal(); setShowBatchModal(true); }}>
                        {t('admin.menus.assignrangemenus')}
                    </Button>
                </Col>
            </Row>
			<Row className="my-3">
                {loading ?
                    <div className="d-flex justify-content-center">
                        <Spinner animation="border" variant="primary" />
                    </div>
                :
                    <FullCalendar
                        displayEventTime={false}
                        ref={calendary}
                        height={'auto'}
                        fixedWeekCount={false}
                        locale={esLocale}
                        weekends={true}
                        plugins={[dayGridPlugin, interactionPlugin]}
                        headerToolbar={{
                            start: 'prev',
                            center: 'title',
                            end: 'next',
                        }}
                        footerToolbar={{
                            center: 'toggleMonth toggleWeek toggleDay',
                        }}
                        customButtons={{
                            toggleDay: {
                                text: t('datatables.hoy'),
                                click: () => {
                                    calendary.current.getApi().changeView('dayGridDay');
                                }
                            },
                            toggleWeek: {
                                text: t('datatables.semana'),
                                click: () => {
                                    calendary.current.getApi().changeView('dayGridWeek');
                                }
                            },
                            toggleMonth: {
                                text: t('datatables.mes'),
                                click: () => {
                                    calendary.current.getApi().changeView('dayGridMonth')
                                }
                            },
                        }}
                        dateClick={e => dateClickHandler(e)}
                        events={events}
                        eventClick={e => eventsHandler(e)}
                    />
                }
			</Row>
            <Modal show={modalShow} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
                    <i className='fa fa-times' onClick={() => {resetBatchModal(); setModalShow(false)}}></i>
                </Modal.Header>
                <Modal.Body>
                    <div className='text-center'>
                        <label className='sd-label-create'>{calendarFormState?.id ? t('admin.menus.editmenu') : t('admin.menus.register')}</label>
                    </div>
                    <Form className="px-4 formulario" onSubmit={handleSubmit}>
                        {!calendarFormState?.id
                        ?
                            <Row className="text-center my-3">
                                <h2 className="sd-label text-start fs-16 fw-400">{t('admin.menus.selectmenuadd')}</h2>
                                <Select
                                    className="text-start p-0"
                                    name={'menucalendar'}
                                    options={menuOptions.options}
                                    value={menuOptions.selected}
                                    onChange={(e) => menuChange(e)}
                                    required
                                />
                            </Row>
                        :
                            <></>
                        }
                        {calendarFormState?.id || showRegister
                            ?
                                <>
                                    <Row className="text-center my-3">
                                        <Col className='p-0'>
                                            <Form.Control
                                                className="sd-input"
                                                type='time'
                                                name='start_time'
                                                value={calendarFormState.start_time || ''}
                                                onChange={(e) => handleInputScheduleChange(e)}
                                                required
                                            />
                                        </Col>
                                        <Col xs={1}>-</Col>
                                        <Col className='p-0'>
                                            <Form.Control
                                                className="sd-input"
                                                type='time'
                                                name='end_time'
                                                value={calendarFormState.end_time || ''}
                                                onChange={(e) => handleInputScheduleChange(e)}
                                                required
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="my-3">
                                        <Col>
                                            <Select
                                            isMulti
                                            options={dishOptions}
                                            onChange={handleDishSelection}
                                            value={selectedDishes}
                                            placeholder={t('admin.calendars.selectDishes')}
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="text-center my-3">
                                        {selectedDishes?.length > 0 ? (
                                        <Table>
                                            <thead>
                                            <tr>
                                                <th className='w-75'>{t('admin.menus.dish')}</th>
                                                <th>{t('admin.menus.comensals')}</th>
                                                <th>{t('admin.menus.ordered')}</th>
                                                <th></th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {selectedDishes.map((selectedDish, index) => (
                                                <tr key={index} className='text-start'>

                                                    <td>- {selectedDish.value.name}</td>
                                                    <td>
                                                        <Form.Control
                                                        className="sd-input"
                                                        type='number'
                                                        id={`comensals-${calendarFormState?.menu}-${index}`}
                                                        name={`comensals-${calendarFormState?.menu}-${index}`}
                                                        value={calendarFormState?.dishesComensals?.[selectedDish.value._id] ?? ''}
                                                        onChange={(e) => handleInputChange(selectedDish.value._id, e)}
                                                        min="1"
                                                        required
                                                        />
                                                    </td>
                                                    <td className='text-center align-middle'>
                                                        {calendarFormState?.dishesOrdered?.[selectedDish.value._id] ? calendarFormState?.dishesOrdered?.[selectedDish.value._id] : 0}
                                                    </td>
                                                    <td className='align-middle'>
                                                        <i className='fas fa-trash cursor' onClick={() => handleRemoveDish(selectedDish.value._id)}></i>
                                                    </td>
                                                </tr>
                                            ))}
                                            </tbody>
                                        </Table>
                                        ) : (
                                        <p>{t('admin.calendars.noDishesSelected')}</p>
                                        )}
                                    </Row>
                                    <Row className="text-center my-3">
                                        <Col className='d-flex justify-content-center'>
                                            {showBatchLoading ?
                                                <Button variant="primary" className='mx-2 my-2' disabled>
                                                    <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> Guardando...
                                                </Button>
                                            :
                                                <Button variant='primary' type="submit" className="mx-2 my-2">
                                                    {isUpdating
                                                        ?
                                                            <>
                                                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                                            </>
                                                        :
                                                            calendarFormState?.id
                                                                ?
                                                                    t('admin.calendars.update')
                                                                :
                                                                    t('admin.calendars.register')

                                                    }
                                                </Button>
                                            }
                                            <Button variant='secondary' type="submit" className="mx-2 my-2" onClick={(e) => unassignMenu(calendarFormState?.id, e)}>{t('admin.calendars.unassign')}</Button>
                                        </Col>
                                    </Row>
                                </>
                            :
                                <></>
                        }
                    </Form>
                </Modal.Body>
            </Modal>
            <Modal show={showBatchModal} size="lg" centered onHide={() => {resetBatchModal(); setShowBatchModal(false)}}>
                <Modal.Header closeButton>
                    <Modal.Title>Asignar Menús en Rango de Fechas</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        {/* Selección de Rango de Fechas */}
                        <Row className="mb-3">
                            <Col>
                                <Form.Label>Fecha de Inicio</Form.Label>
                                <Form.Control type="date" value={dateRange.start} onChange={(e) => setDateRange({ ...dateRange, start: e.target.value })} />
                            </Col>
                            <Col>
                                <Form.Label>Fecha de Fin</Form.Label>
                                <Form.Control type="date" value={dateRange.end} onChange={(e) => setDateRange({ ...dateRange, end: e.target.value })} />
                            </Col>
                        </Row>

                        {/* Selección de Días de la Semana */}
                        <Row className="mb-3">
                            <Form.Label>Días de la Semana</Form.Label>
                            {["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"].map((day, index) => (
                                <Col key={index}>
                                    <Form.Check
                                        type="checkbox"
                                        label={day}
                                        value={index === 6 ? 0 : index + 1}
                                        onChange={(e) => {
                                            const selected = parseInt(e.target.value);
                                            setSelectedWeekdays((prev) =>
                                                prev.includes(selected) ? prev.filter((d) => d !== selected) : [...prev, selected]
                                            );
                                        }}
                                    />
                                </Col>
                            ))}
                        </Row>
                        {/* Selección de Horario y Menú*/}
                        <Row className="mb-3">
                            <Col>
                                <Form.Label>Seleccionar Menú</Form.Label>
                                <Select
                                    options={menuOptions.options}
                                    value={menuOptions.selected}
                                    onChange={(e) => menuChange(e)}
                                    required
                                />
                            </Col>
                            <Col>
                                <Form.Label>Hora de Inicio</Form.Label>
                                <Form.Control type="time" value={calendarFormState.start_time} onChange={(e) => setCalendarFormState({ ...calendarFormState, start_time: e.target.value })} required />
                            </Col>
                            <Col>
                                <Form.Label>Hora de Fin</Form.Label>
                                <Form.Control type="time" value={calendarFormState.end_time} onChange={(e) => setCalendarFormState({ ...calendarFormState, end_time: e.target.value })} required />
                            </Col>
                        </Row>
                        {/* Selección de Platos y comensales */}
                        <Row className="mb-3">
                            <Col>
                                <Form.Label>Seleccionar Platos</Form.Label>
                                <Select
                                    isMulti
                                    options={dishOptions}
                                    onChange={handleDishSelection}
                                    value={selectedDishes}
                                    placeholder="Selecciona los platos"
                                />
                            </Col>
                        </Row>

                        <Row className="mb-3">
                            {selectedDishes.length > 0 && (
                                <Table>
                                    <thead>
                                        <tr>
                                            <th className='w-75'>Plato</th>
                                            <th>Comensales</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {selectedDishes.map((selectedDish, index) => (
                                            <tr key={index}>
                                                <td>{selectedDish.label}</td>
                                                <td>
                                                    <Form.Control
                                                        type="number"
                                                        value={calendarFormState?.dishesComensals?.[selectedDish.value._id] ?? ''}
                                                        onChange={(e) => handleInputChange(selectedDish.value._id, e)}
                                                        min="1"
                                                        required
                                                    />
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            )}
                        </Row>
                        <Row>
                            <Col className="d-flex justify-content-center">
                                {showBatchLoading ?
                                    <Button variant="primary" className='mx-2 my-2' disabled>
                                        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />  Guardando...
                                    </Button>
                                :
                                    <Button variant="primary" className='mx-2' onClick={handleBatchEventCreation}>Asignar Menús</Button>
                                }
                                <Button variant="secondary" className='mx-2' onClick={() => {resetBatchModal();setShowBatchModal(false)}}>Cancelar</Button>
                            </Col>
                        </Row>
                    </Form>
                </Modal.Body>
            </Modal>
        </Container>
	)
}